module.exports = __webpack_public_path__ + "media/images/Go-fe70ceb1504e7588fc74f10d62a7bbda.jpg";